// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2pcax","title":"Images45_title__20cgO","images":"Images45_images___mq-t"};